import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    options: [
        { value: "서울시", label: "서울시" },
        { value: "부산시", label: "부산시" },
        { value: "대구시", label: "대구시" },
        { value: "인천시", label: "인천시" },
        { value: "광주시", label: "광주시" },
        { value: "대전시", label: "대전시" },
        { value: "울산시", label: "울산시" },
        { value: "세종시", label: "세종시" },
        { value: "경기도", label: "경기도" },
        { value: "강원도", label: "강원도" },
        { value: "충청북도", label: "충청북도" },
        { value: "충청남도", label: "충청남도" },
        { value: "전라북도", label: "전라북도" },
        { value: "전라남도", label: "전라남도" },
        { value: "경상북도", label: "경상북도" },
        { value: "경상남도", label: "경상남도" },
        { value: "제주도", label: "제주도" }
    ],
    code: [
        { value: "02", label: "02" },
        { value: "031", label: "031" },
        { value: "032", label: "032" },
        { value: "033", label: "033" },
        { value: "041", label: "041" },
        { value: "042", label: "042" },
        { value: "043", label: "043" },
        { value: "044", label: "044" },
        { value: "051", label: "051" },
        { value: "052", label: "052" },
        { value: "053", label: "053" },
        { value: "054", label: "054" },
        { value: "055", label: "055" },
        { value: "061", label: "061" },
        { value: "062", label: "062" },
        { value: "063", label: "063" },
        { value: "064", label: "064" },
        { value: "070", label: "070" },
        { value: "0", label: "없음" }
    ]
};
export const areaOptionsSlice = createSlice({
    name: "areaOptions",
    initialState: initialState,
    reducers: {
    }
})

// export const {showAlert, hideAlert} = alertSlice.actions;
export default areaOptionsSlice.reducer;